import { AppRecommendation } from '@wix/ambassador-funnel-app-recommendation-v1-app-recommendation/types'
import {
  BANDSINTOWN,
  INSTAGRAM_FEED_NEW,
  PRICING_PLANS,
  WIX_BLOG,
  WIX_BOOKINGS,
  WIX_CHALLENGES,
  WIX_CHAT,
  WIX_EVENTS,
  WIX_FILE_SHARE,
  WIX_FORMS,
  WIX_GROUPS,
  WIX_MUSIC,
  WIX_NEW_STORES,
  WIX_PORTFOLIO,
  WIX_RESTAURANTS_MENUS_NEW,
  WIX_RESTAURANTS_ORDERS,
  WIX_RESTAURANTS_TABLE_RESERVATIONS,
  WIX_VIDEO,
} from '@wix/app-definition-ids'

export const FALLBACK_APPS: AppRecommendation[] = [
  { id: '', appDefId: WIX_NEW_STORES, type: 'Stores', level: 'preferred' },
  { id: '', appDefId: WIX_BOOKINGS, type: 'Bookings', level: 'preferred' },
  { id: '', appDefId: WIX_EVENTS, type: 'Events', level: 'preferred' },

  { id: '', appDefId: WIX_BLOG, type: 'Blog', level: 'regular' },
  { id: '', appDefId: WIX_PORTFOLIO, type: 'portfolio', level: 'regular' },
  { id: '', appDefId: PRICING_PLANS, type: 'PaidPlans', level: 'regular' },
  { id: '', appDefId: WIX_FORMS, type: 'Forms', level: 'regular' },
  { id: '', appDefId: WIX_CHAT, type: 'Chat', level: 'regular' },
  { id: '', appDefId: INSTAGRAM_FEED_NEW, type: 'Instagram', level: 'regular' },
  { id: '', appDefId: WIX_VIDEO, type: 'Video', level: 'regular' },
  { id: '', appDefId: WIX_MUSIC, type: 'Music', level: 'regular' },
  { id: '', appDefId: WIX_CHALLENGES, type: 'Challenges', level: 'regular' },
  { id: '', appDefId: WIX_GROUPS, type: 'Groups', level: 'regular' },
  { id: '', appDefId: WIX_FILE_SHARE, type: 'fileShare', level: 'regular' },
  { id: '', appDefId: WIX_RESTAURANTS_TABLE_RESERVATIONS, type: 'RestaurantsReservations', level: 'regular' },
  { id: '', appDefId: WIX_RESTAURANTS_ORDERS, type: 'RestaurantsOrders', level: 'regular' },
  { id: '', appDefId: WIX_RESTAURANTS_MENUS_NEW, type: 'RestaurantsMenus', level: 'regular' },
  { id: '', appDefId: BANDSINTOWN, type: 'BandsInTown', level: 'regular' },
]
